import { createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../helper/axiosInstance";
import axiosMultipartInstance from "../helper/axiosMultipartInstance";
import Swal from "sweetalert2";
import { Constants } from "../utils/Constants";
import { toast } from "react-toastify";

const initialState = {
  //for messages
  //------------Search Bussiness-------------------
  searchBussinessLoading: false,
  searchBussinessData: [],
  PaginationDataLength: 0,
  startedRecords: 1,
  toRecords: 5,
  totalPages: 0,
  getUsersErr: "",
  CurrentPageNo:1,
  totalAdminPage: 0,
  allAdminData: [],
  AdminPaginationDataLength: 0,
  adminStartedRecords: 1,
  adminToRecords: 20,

  //--------New Bussiness License Verification-----------------
  newBussinessLicenseVerifactionLoading: false,
  newBussinessLicenseVerifactionData: [],
  newBussinessLicenseVerifactionErr: "",

  //--------Pro Bussiness  users-----------------
  proBusinessLoading: false,
  proBusinessData: [],
  proBusinessErr: "",
  //----------Search Customer---------------
  searchCustomerAccountLoading: false,
  searchCustomerAccountData: [],
  searchCustomerAccountErr: "",
  //----------New Customer Account Verification----------------
  newCustomerAccVerificationLoading: false,
  newCustomerAccVerificationData: [],
  newCustomerAccVerificationErr: "",

  //----------Update Customer---------------
  updateCustomerLoading: false,
  updateCustomerData: [],
  updateCustomerErr: "",
  //----------Update Business----------------
  updateBusinessLoading: false,
  updateBusinessData: [],
  updateBusinessErr: "",
  //----------Temp Customer---------------
  tempCustomerAccountLoading: false,
  tempCustomerAccountData: [],

  tempCustomerAccountErr: "",
  tempDeleteUserFailed: "",
  tempDeleteStatus: [],

  //----------UserDetails-----------------
  userDetails: [],
  selectedAccountType: "",
  //----------Create Temp Customer---------------
  createCustomerLoading: false,
  createTempCustomerAccountData: [],
  createCustomerErr: "",
  //----------Create Temp Business----------------
  createBusinessUserLoading: false,
  createTempBusinessAccountData: [],
  createBusinessErr: "",
  //------Temp-Business-Data-------
  tempBusinessDataLoading: false,
  tempBusinessAccountData: [],
  tempBusinessDataError: "",
  //------Delete Search Bussiness Account --------------
  deleteBusinessLoading: false,
  searchBusinessAccountData: [],

  // update user status by id ( Mark as verified )
  markAsVerifiedLoading: false,
  MarkAsVerifiedData: [],
  MarkAsVerifiedError: "",

  // update password for temp customer

  updateTempLoading: false,
  updateTempPassData: "",
  updateFailer: "",

  // Update Profile

  updateProfileLoading: false,
  updateProfileData: [],
  updateprofileError: "",
  // States for filter statics---
  selectedLocationForFilter: "",
  selectedFromDateForFilter: "",
  selectedToDateForFilter: "",
  // Send message
  sendMessageLoading: false,
  sendMessageData: "",
  sendMessageFailed: "",
  // updating Message status
  UpdateMessageLoading: false,
  Updated_message_data: [],
  Updated_message_failed: "",
  // All user activity
  ActivityLoading: false,
  ActivityData: [],
  ActivityfailedError: "",

  ActivityDataLength:0, 
  ActivitystartedRecords:1,
  ActivitytoRecords:20,
  ActivitytotalPages:0,


  Add_msg_Loading: false,
  Add_msg_data: [],
  Add_msg_failed: "",
  // Edit msg
  Edit_msg_Loading: false,
  Edit_msg_data: [],
  Edit_msg_failed: "",
  loading: false,
  selectedOption: '',
  UserStatusloading:false,
};

export const getUsersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {

    //pagination is here
    // getAllAdminSuccess: (state, action) => {
    //   state.getAllAdminLoading = false;
    //   state.allAdminData = action.payload[0];
    //   state.AdminPaginationDataLength = action.payload[1];
    //   state.adminStartedRecords = (action.payload.CurrentPage - 1) * 2 + 1;
    //   state.adminToRecords = action.payload.CurrentPage * 2;
    //   state.totalAdminPage = Math.ceil(action.payload[1] / Constants.TAKE);
    // },
    //==========Search Bussiness ==============================
    getAllsearchBussiness: (state) => {
      state.searchBussinessLoading = true;
    },
    getAllsearchBussinessSuccess: (state, action) => {
      state.searchBussinessLoading = false;
      state.searchBussinessData = action.payload[0];
      state.PaginationDataLength = action.payload[1];
      state.startedRecords =
        (action.payload.CurrentPage - 1) * Constants.TAKE + 1;
      state.toRecords = Math.min(
        action.payload.CurrentPage * Constants.TAKE,
        action.payload[1]
      );
      state.CurrentPageNo=action.payload.CurrentPage ;
      state.totalPages = Math.ceil(action.payload[1] / Constants.TAKE);
    },
    getAllsearchBussinessFailed: (state, action) => {
      state.searchBussinessLoading = false;
      state.getUsersErr = "Unable to get business";
    },
    //===============New Bussiness Account Verification ============
    getAllBussinessLicenseVerification: (state) => {
      state.newBussinessLicenseVerifactionLoading = true;
    },
    getAllBussinessLicenseVerificationData: (state, action) => {
    state.newBussinessLicenseVerifactionLoading = false;
      state.CurrentPageNo=action.payload.CurrentPage ;
      state.newBussinessLicenseVerifactionData = action.payload[0];
      state.PaginationDataLength = action.payload[1];
      state.startedRecords =
        (action.payload.CurrentPage - 1) * Constants.TAKE + 1;
      state.toRecords = Math.min(
        action.payload.CurrentPage * Constants.TAKE,
        action.payload[1]
      );
      state.totalPages = state.totalPages = Math.ceil(
        action.payload[1] / Constants.TAKE
      );
    },
    getAllBussinessLicenseVerification_filtered_Data: (state, action) => {
      state.newBussinessLicenseVerifactionLoading = false;
      state.newBussinessLicenseVerifactionData = action.payload[0].filter(
        function (Data) {
          return Data?.userToCustomiseMsgTblIdTbl !== null;
        }
      );
      // state.newBussinessLicenseVerifactionData = action.payload[0];
      state.CurrentPageNo=action.payload.CurrentPage ;
      state.PaginationDataLength = action.payload[1];
      state.startedRecords =
        (action.payload.CurrentPage - 1) * Constants.TAKE + 1;
      state.toRecords = Math.min(
        action.payload.CurrentPage * Constants.TAKE,
        action.payload[1]
      );
      state.totalPages = state.totalPages = Math.ceil(
        action.payload[1] / Constants.TAKE
      );
    },
    getAllBussinessLicenseVerificationFailed: (state, action) => {
      state.newBussinessLicenseVerifactionLoading = false;
      state.newBussinessLicenseVerifactionErr = "Unable to get business";
    },

    //==================Search Customer==========================
    getAllsearchCustomer: (state) => {
      state.searchCustomerAccountLoading = true;
    },
    getAllsearchCustomerSuccess: (state, action) => {
      console.log("action: ", action.payload);
      state.searchCustomerAccountLoading = false;
      state.searchCustomerAccountData = action.payload[0];

      // state.searchCustomerAccountData = action.payload?.filter(function (Data) {
      //   return (
      //     Data?.data?.tempAccount === 0 && Data?.data?.isAdminApproved === 1
      //   );
      // });
      state.PaginationDataLength = action.payload[1];
      state.CurrentPageNo=action.payload.CurrentPage ;
      state.startedRecords =
        (action.payload.CurrentPage - 1) * Constants.TAKE + 1;
      state.toRecords = Math.min(
        action.payload.CurrentPage * Constants.TAKE,
        action.payload[1]
      );
      state.totalPages = state.totalPages = Math.ceil(
        action.payload[1] / Constants.TAKE
      );
    },
    getAllsearchCustomerFailed: (state, action) => {
      state.searchCustomerAccountLoading = false;
      state.searchCustomerAccountErr = "Unable to get customer";
    },

    //=================New Customer Account Verification====================
    getAllnewAccountVerifation: (state) => {
      state.newCustomerAccVerificationLoading = true;
    },
    getAllnewAccountVerifationSuccess: (state, action) => {
      state.newCustomerAccVerificationLoading = false;
      if (action.payload?.item) {
        state.newCustomerAccVerificationData = (
          action.payload?.item[0] || []
        ).filter((Data) => {
          console.log("Data....", Data);
          return Data?.isReview === false;
        });
      } else {
        state.newCustomerAccVerificationData = action.payload[0];
      }

      state.PaginationDataLength = action.payload[1];
      state.startedRecords =
        (action.payload.CurrentPage - 1) * Constants.TAKE + 1;
      state.toRecords = Math.min(
        action.payload.CurrentPage * Constants.TAKE,
        action.payload[1]
      );
      state.totalPages = Math.ceil(action.payload[1] / Constants.TAKE);
      state.CurrentPageNo=action.payload.CurrentPage ;
    },
    getAllnewAccountVerifationFailed: (state) => {
      state.newCustomerAccVerificationLoading = false;
      state.newCustomerAccVerificationErr = "Unable to get customer";
    },

    //==================Temp Customer==========================
    getAllTempCustomer: (state) => {
      state.tempCustomerAccountLoading = true;
    },
    getAllTempCustomerSuccess: (state, action) => {
      console.log('action.payload....',action.payload)
      state.tempCustomerAccountLoading = false;
      state.tempCustomerAccountData = action.payload[0];
      state.searchCustomerAccountLoading = false;
      state.PaginationDataLength = action.payload[1];
      state.startedRecords =
        (action.payload.CurrentPage - 1) * Constants.TAKE + 1;
      state.toRecords = Math.min(
        action.payload.CurrentPage * Constants.TAKE,
        action.payload[1]
      );
      state.totalPages = Math.ceil(action.payload[1] / Constants.TAKE);
      state.CurrentPageNo=action.payload.CurrentPage ;
    },
    getAllMessageSuccess: (state, action) => {
      state.updateMessage = action.payload;
    },
    //-----------------------------------------------------------------------------------------------------
    getAllTempCustomerFailed: (state) => {
      state.tempCustomerAccountLoading = false;
      state.tempCustomerAccountErr = "Unable to get customer";
    },

    //==================Temp Customer Create==========================
    createCustomer: (state) => {
      state.createCustomerLoading = true;
    },
    createCustomerSuccess: (state, action) => {
      // console.log(action.payload);
      // state.createTempCustomerAccountData = action.payload;
      state.createCustomerLoading = false;
      // state.tempCustomerAccountData = [
      //   ...state.tempCustomerAccountData,
      //   action.payload,
      // ];
    },
    createCustomerFailed: (state) => {
      state.createCustomerLoading = false;
      state.createCustomerErr = "Unable to create customer";
    },

    //==================Temp Business==========================
    getAllTempBusiness: (state) => {
      state.tempBusinessDataLoading = true;
    },
    getAllTempBusinessSuccess: (state, action) => {
      state.tempBusinessDataLoading = false;
      state.tempBusinessAccountData = action.payload[0];
      state.PaginationDataLength = action.payload[1];
      state.startedRecords =
        (action.payload.CurrentPage - 1) * Constants.TAKE + 1;
      state.toRecords = Math.min(
        action.payload.CurrentPage * Constants.TAKE,
        action.payload[1]
      );
      state.totalPages = Math.ceil(action.payload[1] / Constants.TAKE);
      state.CurrentPageNo=action.payload.CurrentPage ;
    },

    getAllTempBusinessFailed: (state) => {
      state.tempBusinessDataLoading = false;
      state.createBusinessErr = "Unable to create business";
    },
    //==================Temp Business Create==========================
    createBusiness: (state) => {
      state.createBusinessUserLoading = true;
    },
    createBusinessSuccess: (state, action) => {
      state.createBusinessUserLoading = false;
      console.log("Business creates response ,,,,", action.payload);
      state.createTempBusinessAccountData = action.payload;
    },
    createBusinessFailed: (state) => {
      state.createBusinessUserLoading = false;
      state.tempCustomerAccountErr = "Unable to get customer";
    },

    //==================Pro Business==========================
    getAllProBusiness: (state) => {
      state.proBusinessLoading = true;
    },
    getAllProBusinessFailed: (state) => {
      state.proBusinessLoading = false;
      state.proBusinessErr = "unable to get pro business user";
    },
    getAllProBusinessSuccess: (state, action) => {
      state.proBusinessLoading = false;
      state.proBusinessData = action.payload[0].filter(function (Item) {
        return Item.status === true;
      });
      state.PaginationDataLength = action.payload[1];
      state.startedRecords =
        (action.payload.CurrentPage - 1) * Constants.TAKE + 1;
      state.toRecords = Math.min(
        action.payload.CurrentPage * Constants.TAKE,
        action.payload[1]
      );
      state.totalPages = state.totalPages = Math.ceil(
        action.payload[1] / Constants.TAKE
      );
      state.CurrentPageNo=action.payload.CurrentPage ;
    },

    //==================Update Customer==========================
    updateCustomer: (state, action) => {
      for (
        let index = 0;
        index < state.newCustomerAccVerificationData.length;
        index++
      ) {
        if (
          action.payload ===
          state.newCustomerAccVerificationData[index].emailAddress
        ) {
          state.newCustomerAccVerificationData[index].isAdminApproved = true;
        }
      }
      state.updateCustomerLoading = true;
      state.newCustomerAccVerificationData = [
        ...state.newCustomerAccVerificationData,
      ];
    },
    updateCustomerSuccess: (state, action) => {
      state.updateCustomerLoading = false;
      state.updateCustomerData = action.payload;
      state.newCustomerAccVerificationData =
        state.newCustomerAccVerificationData.filter(
          (i) => i.emailAddress !== action.payload
        );
    },
    updateCustomerFailed: (state) => {
      state.updateCustomerLoading = false;
      state.updateCustomerErr = "Unable to update customer";
    },
    setLoading: (state, action) => {
      state.loading = true;
    },
    setUserLoading: (state,action) => {
      state.UserStatusloading = action.payload;
    },
   
  
    clearLoading: (state) => {
      state.loading = false; // Set loading to false
    },
    refreshSuccess: (state, action) => {
      if (action.payload.accountType == "business") {
        // Filter the data based on the payload's id
        let newData = state.newBussinessLicenseVerifactionData.filter(
          (item) => {
            // Return true for items that match the condition
            return item.id === action.payload.id;
          }
        );

        state.loading = false;

        // If you want to replace the original state data with the filtered one:
        // state.newBussinessLicenseVerifactionData = newData;

        // Uncomment this if you need to update the state directly
        state.newBussinessLicenseVerifactionData =
          state.newBussinessLicenseVerifactionData.map((item) =>
            item.id === action.payload.id ? action.payload : item
          );
      }
      if (action.payload.accountType == "customer") {
        let newData = state.newCustomerAccVerificationData.filter((item) => {
          return item.id === action.payload.id;
        });
        state.loading = false;

        // If you want to replace the original state data with the filtered one:
        // state.newBussinessLicenseVerifactionData = newData;

        // Uncomment this if you need to update the state directly
        state.newCustomerAccVerificationData =
          state.newCustomerAccVerificationData.map((item) =>
            item.id === action.payload.id ? action.payload : item
          );
      }
    },

    refreshFailed: (state, action) => {
      state.loading = false; // Clear loading on failure
      state.error = action.payload; // Store error if needed
    },

    //=================Update Business====================
    updateBusiness: (state, action) => {
      for (
        let index = 0;
        index < state.newBussinessLicenseVerifactionData.length;
        index++
      ) {
        if (
          action.payload ===
          state.newBussinessLicenseVerifactionData[index].emailAddress
        ) {
          console.log("Business found");
          state.newBussinessLicenseVerifactionData[
            index
          ].isAdminApproved = true;
        }
      }
      state.updateBusinessLoading = true;

      if (action.payload.fromNotification) {
        state.updateBusinessLoading = false;
      } else {
        state.updateBusinessLoading = true;
      }

      state.newBussinessLicenseVerifactionData = [
        ...state.newBussinessLicenseVerifactionData,
      ];
    },
    updateBusinessSuccess: (state, action) => {
      state.updateBusinessLoading = false;
      state.updateBusinessData = action.payload;
      if (action.payload.PrevVeried === true) {
        state.searchBussinessData = state.searchBussinessData?.filter(
          (i) => i?.id !== action.payload?.id
        );
      } else {
        state.newBussinessLicenseVerifactionData =
          state.newBussinessLicenseVerifactionData?.filter(
            (i) => i?.id !== action.payload?.id
          );
      }
      // state.newBussinessLicenseVerifactionData =
      //   state.newBussinessLicenseVerifactionData.filter(
      //     (i) => i.id !== action.payload
      //   );
    },

    updateBusinessReviewSuccess: (state, action) => {
      state.updateBusinessLoading = false;
      state.updateBusinessData = action.payload;
      state.newBussinessLicenseVerifactionData.isReview =
        action.payload.isReview;
    },

    updateBusinessFailed: (state, action) => {
      state.updateBusinessLoading = false;
      state.updateBusinessErr = "Unable to update business";
    },

    //Delete Customer
    deleteCustomer: (state) => {
      state.searchCustomerAccountLoading = true;
      // state.deleteCustomerError = "";
      state.newCustomerAccVerificationLoading = true;
    },
    deleteCustomerSuccess: (state, action) => {
      state.searchCustomerAccountLoading = false;
      state.newCustomerAccVerificationLoading = false;
      state.searchCustomerAccountData = state.searchCustomerAccountData.filter(
        (i) => i.id !== action.payload
      );
      state.newCustomerAccVerificationData =
        state.newCustomerAccVerificationData.filter(
          (i) => i.id !== action.payload
        );
      state.tempCustomerAccountData = state.tempCustomerAccountData.filter(
        (i) => i.id !== action.payload
      );
    },
    deleteCustomerFailed: (state, action) => {
      state.searchCustomerAccountLoading = false;
      state.newCustomerAccVerificationLoading = false;
      state.deleteCustomerError = action.payload;
    },

    //Delete Business
    deleteBusiness: (state) => {
      state.deleteBusinessLoading = true;
      state.deleteBusinessError = "";
    },
    deleteBusinessSuccess: (state, action) => {
      state.deleteBusinessLoading = false;
      state.searchBussinessData = state.searchBussinessData.filter(
        (i) => i.id !== action.payload
      );
      state.newBussinessLicenseVerifactionData =
        state.newBussinessLicenseVerifactionData.filter(
          (i) => i.id !== action.payload
        );
      state.tempBusinessAccountData = state.tempBusinessAccountData.filter(
        (i) => i?.id !== action.payload
      );
    },
    deleteBusinessFailed: (state, action) => {
      state.deleteBusinessLoading = false;
      state.deleteBusinessError = action.payload;
    },
    deleteTempUser: (state) => {
      state.tempCustomerAccountLoading = true;
    },
    deleteTempStatus: (state, action) => {
      state.tempCustomerAccountLoading = false;
      state.tempDeleteStatus = action.payload;
    },
    deleteTempUserSuccess: (state, action) => {
      state.tempCustomerAccountLoading = false;
      state.tempCustomerAccountData = state.tempCustomerAccountData.filter(
        (i) => i.id !== action.payload
      );
    },
    deleteTempUserFailed: (state) => {
      state.tempCustomerAccountLoading = false;
      state.tempDeleteUserFailed = "Unable to delete the user";
    },
    selectedUserDetails: (state, action) => {
      state.userDetails = action.payload;
    },
    UserAccountType: (state, action) => {
      state.selectedAccountType = action.payload;
    },
    signUpTemporaryAccount: (state) => { },

    VerifyUser: (state) => {
      state.newCustomerAccVerificationLoading = true;
    },
    VerifyBusinessUser: (state) => {
      state.updateBusinessLoading = true;
    },
    VerifyUserSuccess: (state, action) => {
      state.newCustomerAccVerificationLoading = false;
      if (action.payload.PrevVeried === true) {
        state.searchCustomerAccountData =
          state.searchCustomerAccountData?.filter(
            (i) => i?.id !== action.payload?.id
          );
      } else {
        state.newCustomerAccVerificationData =
          state.newCustomerAccVerificationData?.filter(
            (i) => i?.id !== action.payload?.id
          );
      }
    },

    VerifyUserReviewSuccess: (state, action) => {
      state.newCustomerAccVerificationLoading = false;
      state.newCustomerAccVerificationData.isReview = action.payload.isReview;
    },
  

    updateUserLastMsg: (state, action) => {
      console.log('Calling lasmsg ', action.payload);
    
      if(state.userDetails?.id === action.payload?.id){
        state.userDetails ={ ...state.userDetails ,  isLastMsgRead: action.payload.isLastMsgRead}
      }


      if(action.payload?.accountType === 'business'){
        console.log('Calling lastmsg for business', action.payload);
    
        state.newBussinessLicenseVerifactionData = state.newBussinessLicenseVerifactionData.map(user => {
          if(user.id === action.payload.id) { // assuming `id` is the unique identifier
            return { ...user, isLastMsgRead: action.payload.isLastMsgRead,};
          }
          return user;
        });
    
      } else {
        console.log('Calling last msg for customer', action.payload);
    
        state.newCustomerAccVerificationData = state.newCustomerAccVerificationData.map(user => {
          if(user.id === action.payload.id) {
            console.log('Calling last msg for inside customer', action.payload?.isLastMsgRead);
            return { ...user,  isLastMsgRead: action.payload.isLastMsgRead};
          }
          return user;
        });
      }
    },



    createUserConnectionSuccess: (state, action) => {
      console.log('Calling connection ', action.payload);
    
      if(action.payload?.accountType === 'business'){
        console.log('Calling connection for business', action.payload);
    
        state.newBussinessLicenseVerifactionData = state.newBussinessLicenseVerifactionData.map(user => {
          if(user.id === action.payload.id) { // assuming `id` is the unique identifier
            return { ...user, connectedToAdmin: action.payload.connectedToAdmin,connectedTo:action.payload.connectedTo };
          }
          return user;
        });
    
      } else {
        console.log('Calling connection for customer', action.payload);
    
        state.newCustomerAccVerificationData = state.newCustomerAccVerificationData.map(user => {
          if(user.id === action.payload.id) {
            return { ...user, connectedToAdmin: action.payload.connectedToAdmin ,connectedTo:action.payload.connectedTo};
          }
          return user;
        });
      }
    },
    
    updateUserConnectionWithChatSuccess: (state, action) => {
      console.log('Calling connection ', action.payload?.isSameChatRoom?.businessId);
    if(action.payload.blur){
      if(action.payload?.isSameChatRoom?.businessId){
        console.log('Calling connection for business', action.payload);
        state.newBussinessLicenseVerifactionData = state.newBussinessLicenseVerifactionData.map(user => {
          if(user.id === action.payload?.isSameChatRoom?.businessId) { // assuming `id` is the unique identifier
            return { ...user, connectedTo:  action.payload?.isSameChatRoom?.connectedTo };
          }
          return user;
        });
    
      } else {
        console.log('Calling connection for customer blur',  action.payload?.isSameChatRoom?.customerId);
    
        state.newCustomerAccVerificationData = state.newCustomerAccVerificationData.map(user => {
          if(user.id === action.payload?.isSameChatRoom?.customerId) {
            console.log('updatded for blur', action.payload.isSameChatRoom?.connectedTo);
            
            return { ...user, connectedTo : action.payload.isSameChatRoom?.connectedTo  };
          }
          return user;
        });
      }
    }else if (!action.payload.blur){
      if(action.payload?.accType === 'business'){
        console.log('Calling connection for business', action.payload);
        state.newBussinessLicenseVerifactionData = state.newBussinessLicenseVerifactionData.map(user => {
          if(user.id === action.payload?.id) { // assuming `id` is the unique identifier
            return { ...user, connectedTo:  null };
          }
          return user;
        });
    
      } else {
        console.log('Calling connection for customer unblur', action.payload);
        state.newCustomerAccVerificationData = state.newCustomerAccVerificationData.map(user => {
          if(user.id === action.payload?.id) {
            return { ...user, connectedTo : null };
          }
          return user;
        });
      }
    }
     
    },

    VerifyUserFailed: (state) => { 
      state.newCustomerAccVerificationLoading = false;
      state.MarkAsVerifiedData = "Unable to verify user";
    },

    UpdateTempPass: (state) => {
      state.updateTempLoading = true;
    },
    UpdateTempPassSuccess: (state, action) => {
      state.updateTempLoading = false;
      state.updateTempPassData = action.payload;
    },
    UpdateTempPassFailed: (state) => {
      state.updateTempLoading = false;
      state.updateFailer = "somthing went wrong ";
    },

    // Update profile custome and business
    UpdateTheProfile: (state) => {
      state.updateProfileLoading = true;
    },
    UpdateProfileSuccess: (state, action) => {
      state.updateProfileLoading = false;
      state.updateProfileData = action.payload;
    },
    UpdateProfileFailed: (state, action) => {
      state.updateProfileLoading = false;
      state.updateprofileError = action.payload;
    },
    updateDeletionRequestStatus: (state, action) => {
      const { BusinessOrCustomerId, accountType } = action.payload;
      if (accountType === "customer") {
        state.newCustomerAccVerificationData = state.newCustomerAccVerificationData.map((user) => {
          if (user.id === BusinessOrCustomerId) {
            return { ...user, isDeletedRequest: false };
          }
          return user;
        });
      } else {
        state.newBussinessLicenseVerifactionData = state.newBussinessLicenseVerifactionData.map((user) => {
          if (user.id === BusinessOrCustomerId) {
            return { ...user, isDeletedRequest: false };
          }
          return user;
        });
      }
    },
    /////----Location Select
    SelectedFilterLocation: (state, action) => {
      state.selectedLocationForFilter = action.payload;
    },
    SelectedFilterFromDate: (state, action) => {
      state.selectedFromDateForFilter = action.payload;
    },
    Clear_From_Date_location: (state) => {
      state.selectedLocationForFilter = "";
      state.selectedFromDateForFilter = "";
    },
    SelectedFilterToDate: (state, action) => {
      state.selectedToDateForFilter = action.payload;
    },
    Send_Message: (state) => {
      state.sendMessageLoading = true;
    },
    Send_Message_Success: (state, action) => {
      state.sendMessageLoading = false;
      state.sendMessageData = action.payload;
    },
    Send_Message_Failed: (state, action) => {
      state.sendMessageLoading = false;
      state.sendMessageFailed = action.payload;
    },

    // Update message status:
    Update_messsage_Status: (state) => {
      state.UpdateMessageLoading = true;
    },
    Update_messsage_Status_Success: (state, action) => {
      state.UpdateMessageLoading = false;
      state.Updated_message_data = action.payload;
    },
    Update_messsage_Status_Failed: (state, action) => {
      state.UpdateMessageLoading = false;
      state.Updated_message_failed = action.payload;
    },
    //fetch activity:
    fetch_activity: (state) => {
      state.ActivityLoading = true;
    },
   fetch_activity_Success: (state, action) => {
      console.log('actionpayload',action.payload)
      state.ActivityLoading = false;
      state.ActivityData = action.payload?.activities;
      state.ActivityDataLength = action.payload?.total;
      state.ActivitystartedRecords = (action.payload.CurrentPage - 1) * Constants.TakeForChatUser + 1;
      state.ActivitytoRecords = Math.min( action.payload.CurrentPage * Constants.TakeForChatUser, action.payload?.total);
      state.ActivityCurrentPageNo=action.payload.CurrentPage ;
      state.ActivitytotalPages = Math.ceil(action.payload?.total / Constants.TakeForChatUser);

    },
    fetch_activity_Failed: (state, action) => {
      state.ActivityLoading = false;
      state.ActivityfailedError = action.payload;
    },
    // Add new message :
    AddNewMsg: (state) => {
      state.Add_msg_Loading = true;
    },
    AddNewMsgSuccess: (state, action) => {
      state.Add_msg_Loading = false;
      state.updateMessage = [...state.updateMessage, action.payload];
    },
    AddNewMsgFailed: (state, action) => {
      state.Add_msg_Loading = false;
      state.Add_msg_failed = action.payload;
    },
    // Update message :
    EditMsg: (state) => {
      state.Edit_msg_Loading = true;
    },
    EditMsgSuccess: (state, action) => {
      state.Edit_msg_Loading = false;
      state.Edit_msg_data = action.payload;
    },
    EditMsgFailed: (state, action) => {
      state.Edit_msg_Loading = false;
      state.Edit_msg_failed = action.payload;
    },

    phoneVerification: (state, action) => {
      const newData = action.payload;
      return {
        ...state,
        newCustomerAccVerificationData: [
          newData,
          ...state.newCustomerAccVerificationData.filter(
            (i) => i?.id !== newData?.id
          ),
        ],
      };
    },
    setSelectedOption: (state, action) => {
      state.selectedOption = action.payload;
    },
    RefreshUserCustomer: (state, action) => {
      const newData = action.payload;
      return {
        ...state,
        newCustomerAccVerificationData: [
          newData,
          ...state.newCustomerAccVerificationData.filter(
            (i) => i?.id !== newData?.id
          ),
        ],
      };
    },
    RefreshUserBusiness: (state, action) => {
      const newData = action.payload;
      return {
        ...state,
        newBussinessLicenseVerifactionData: [
          newData,
          ...state.newBussinessLicenseVerifactionData.filter(
            (i) => i?.id !== newData?.id
          ),
        ],
      };
    },
    UpdateIsLastMsgRead: (state, action) => {
      console.log('UpdateUSER', action.payload)
      const data = action.payload?.chatUser;

      if (
        data?.accountType === "customer" &&
        (data?.isAdminApproved === true || data?.isAdminApproved === 1)
      ) {
        state.searchCustomerAccountData = state.searchCustomerAccountData?.map(
          (user) => {
            if (user?.id === data?.id) {
              return {
                ...user,
                isLastMsgRead: false,
              };
            }
            return user;
          }
        );
      } else if (
        data?.accountType === "customer" &&
        (data?.isAdminApproved === false || data?.isAdminApproved === 0)
      ) {

        state.newCustomerAccVerificationData =
          state.newCustomerAccVerificationData?.map((user) => {
            if (user?.id === data?.id) {
              return {
                ...user,
                isLastMsgRead: false,
              };
            }
            return user;
          });
      } else if (
        data?.accountType === "business" &&
        (data?.isAdminApproved === true || data?.isAdminApproved === 1)
      ) {
        state.searchBussinessData = state.searchBussinessData?.map((user) => {
          if (user?.id === data?.id) {
            console.log("IsMAthced", user?.userId);
            return {
              ...user,
              isLastMsgRead: false,
            };
          }
          return user;
        });
      } else if (
        data.accountType === "business" &&
        (data?.isAdminApproved === false || data?.isAdminApproved === 0)
      ) {
        state.newBussinessLicenseVerifactionData =
          state.newBussinessLicenseVerifactionData?.map((user) => {
            if (user?.id === data?.id) {
              return {
                ...user,
                isLastMsgRead: false,
              };
            }
            return user;
          });
      } else if (
        data.accountType === "business" &&
        (data?.isAdminApproved === true || data?.isAdminApproved === 1) &&
        (data.status === true || data.status === 1)
      ) {
        state.proBusinessData = state.proBusinessData?.map((user) => {
          if (user?.id === data?.id) {

            return {
              ...user,
              isLastMsgRead: false,
            };
          }
          return user;
        });
      }
    },
  },
});

export const UpdateUserForChat = (data) => (dispatch) => {
  dispatch(UpdateIsLastMsgRead(data));
};

//Get Businesses Action
export const getSearchBusinessAsync = (data) => (dispatch) => {
  if (data?.demo === 1) {
    dispatch(getAllTempBusiness());
  } else if (data?.isAdminApproved === 1) {
    dispatch(getAllsearchBussiness());
    dispatch(getAllProBusiness());
  } else {
    dispatch(getAllBussinessLicenseVerification());
  }
  axiosInstance
    .get("/BusisnessUser/GetBuisnessUserForAdmin", {
      params: {
        location: data.location,
        Email: data.email,
        address: data.address,
        isAdminApproved: data.isAdminApproved,
        businessName: data?.businessName,
        phoneNumber: data.phoneNumber,
        demo: data?.demo,
        page: data.page,
        perPage: data.perPage,
        status: data?.status,
        adminId: data?.adminId,
        DeletedCombined:data?.DeletedCombined,
        withoutDocs:data?.withoutDocs,
        recentUpdate:data?.recentUpdate,
        HideAccountWithSendMsg :data?.HideAccountWithSendMsg
      },
    })
    .then((response) => {
      response.data.CurrentPage = data.page;
      if (response?.status === 200 || 201) {
        console.log("ResR", response);
        if (data?.demo === 1) {
          dispatch(getAllTempBusinessSuccess(response?.data));
        } else if (data?.isAdminApproved === 1) {
          dispatch(getAllProBusinessSuccess(response?.data));
          dispatch(getAllsearchBussinessSuccess(response?.data));
        } else if (data?.isAdminApproved === 0) {
          if (data?.sendMessages === true) {
            dispatch(
              getAllBussinessLicenseVerification_filtered_Data(response?.data)
            );
          } else {
            dispatch(getAllBussinessLicenseVerificationData(response?.data));
          }
        }
      }
    })
    .catch((err) => {
      if (err) {
        dispatch(getAllsearchBussinessFailed());
        dispatch(getAllProBusinessFailed());
        dispatch(getAllBussinessLicenseVerificationFailed());
      }
    });
};

//Update Business Action
export const updateBusinessAsync =
  (userId, isAdminApproved, isReview, fromNotification) => (dispatch) => {
    let data = { isAdminApproved, userId, fromNotification, isReview };
    if (isAdminApproved) {
      dispatch(updateBusiness(data));
    }
    axiosInstance
      .post("BusisnessUser/UpdateBusinessUserTblProfile", {
        userId,
        isAdminApproved,
        isReview,
      })
      .then((response) => {
        console.log(response);
        if (isAdminApproved) {
          dispatch(updateBusinessSuccess(userId));
        } else {
          let data = {
            userId,
            isReview,
          };
          dispatch(updateBusinessReviewSuccess(data));
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch(updateBusinessFailed());
      });
  };

export const sendMessageToUser = (Data) => async (dispatch) => {
  dispatch(Send_Message());
  try {
    const response = await axiosInstance.post(
      "Login/saveIdsOfUser&CustomMsgTbl",
      Data
    );
    dispatch(Send_Message_Success(response?.data));
    if (response?.data?.updatedmessage?.customer) {
      dispatch(RefreshUserCustomer(response?.data?.updatedmessage?.customer))
    } else {
      dispatch(RefreshUserBusiness(response?.data?.updatedmessage?.business))
    }
    return response;
  } catch (err) {
    dispatch(Send_Message_Failed(err?.response));
    console.log(err);
    return err;
  }
};

//add message action
export const addMessages = () => (dispatch) => {
  axiosInstance
    .post("/AdminConroller/writeMessage")
    .then((response) => {
      dispatch(getAllMessageSuccess(response?.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

//get message action
export const getMessageCustomerAsync = () => (dispatch) => {
  axiosInstance
    .get("AdminConroller/getCustumMessage")
    .then((response) => {
      dispatch(getAllMessageSuccess(response?.data));
    })
    .catch((err) => {
      console.log(err);
      // dispatch(updateBusinessFailed());
    });
};

// Write new message
export const AddNewMessageAsync = (msg) => async (dispatch) => {
  let data = {
    Message: msg,
  };
  dispatch(AddNewMsg());
  try {
    const response = await axiosInstance.post(
      "/AdminConroller/writeMessage",
      data
    );
    if (response) {
      dispatch(AddNewMsgSuccess(response?.data?.wroteMessage));
    }
  } catch (err) {
    dispatch(AddNewMsgFailed(err));
  }
};

// Edit message Action---
export const EditMessageAsync = (data) => async (dispatch) => {
  dispatch(EditMsg());
  try {
    const response = await axiosInstance.post(
      "/AdminConroller/UpdateCustomMsg",
      data
    );
    if (response) {
      dispatch(EditMsgSuccess(response));
      return response;
    }
  } catch (err) {
    dispatch(EditMsgFailed(err));
  }
};

//Get Customers Action
export const getSearchCustomerAsync = (data, recentUpdate) => (dispatch) => {
  if (data?.temp === 1) {
    dispatch(getAllTempCustomer());
  } else if (data?.isAdminApproved === 1) {
    dispatch(getAllsearchCustomer());
  } else {
    dispatch(getAllnewAccountVerifation());
  }
  axiosInstance
    .get("Login/GetCustomersForAdmin", {
      params: {
        name: data.name,
        location: data.location,
        email: data.email,
        username: data.userName,
        address: data.address,
        phoneNumber: data.phoneNumber,
        isAdminApproved: data.isAdminApproved,
        page: data?.page,
        perPage: data?.perPage,
        temp: data?.temp,
        adminId: data?.adminId,
        DeletedCombined: data?.DeletedCombined,
        withoutDocs:data?.withoutDocs,
        recentUpdate:data?.recentUpdate,
        HideAccountWithSendMsg :data?.HideAccountWithSendMsg

        // isSort: data?.isSort,
      },
    })
    .then((response) => {
      if (response.data) {
        console.log("resp", response);
        response.data.CurrentPage = data?.page;
        if (data?.temp === 1) {
          dispatch(getAllTempCustomerSuccess(response?.data));
        } else if (data?.isAdminApproved === 1) {
          dispatch(getAllsearchCustomerSuccess(response?.data));
        } else {
          if (recentUpdate === false) {
            dispatch(
              getAllnewAccountVerifationSuccess({ item: response?.data })
            );
          } else {
            dispatch(getAllnewAccountVerifationSuccess(response?.data));
          }
        }
      }
    })
    .catch((err) => {
      console.log("eroorrr", err);
      if (data?.temp === 1) {
        dispatch(getAllTempCustomerFailed());
      } else if (data.isAdminApproved === 1) {
        dispatch(getAllsearchCustomerFailed());
      } else {
        dispatch(getAllnewAccountVerifationFailed());
      }
      toast.error(err?.response?.data?.message);
    });
};

//Update Customer Action
export const updateCustomerAsync =
  (emailAddress, isAdminApproved) => (dispatch) => {
    dispatch(updateCustomer(emailAddress));

    axiosInstance
      .post("Login/UpdateCustomerProfile", {
        emailAddress,
        isAdminApproved,
      })
      .then((response) => {
        console.log(response);

        dispatch(updateCustomerSuccess(emailAddress));
      })
      .catch((err) => {
        console.log(err);

        dispatch(updateCustomerFailed());
      });
  };
//Delete Customer Action
export const deleteCustomerAsync = (data) => async (dispatch) => {
  // const data = data?.id;
  if (data?.userType === "customer") {
    dispatch(deleteCustomer(data?.CustomerId));
  } else {
    dispatch(deleteTempUser(data?.CustomerId));
    dispatch(deleteBusiness());
  }
  try {
    const response = await axiosInstance.delete("/Login/DeleteCustomerUser/", {
      params: {
        CustomerId: data?.CustomerId,
        accountType:data.accountType,
        adminUserId: data?.adminUserId
      },
    });
    if (response) {
      if (response?.status === 200 || 201) {
        dispatch(deleteTempUserSuccess(data?.CustomerId));
        dispatch(deleteBusinessSuccess(data?.CustomerId));
        dispatch(deleteTempStatus(data?.CustomerId));
        toast.success("User Deleted Successfully!!");
        return true;
      } else {
        toast.error("User not Deleted !!");
      }
    }
  } catch (err) {
    dispatch(deleteTempUserFailed(err.response.data));
    dispatch(deleteBusinessFailed(err.response.data));
    return false;
  }
};

//Delete Business Action
export const deleteBusinessAsync = (id) => async (dispatch) => {
  dispatch(deleteBusiness());
  try {
    const response = await axiosInstance.delete(
      "BusisnessUser/DeleteBusinessUser",
      {
        params: {
          BusinessUserId: id,
        },
      }
    );
    if (response) {
      console.log('reoooooo',response)
      dispatch(deleteBusinessSuccess(id));
      if (response?.status === 200 || 201) {
        toast.success("User Deleted Successfully!!");
        return true;
      } else {
        toast.error("User not Deleted !!");
      }
    }
  } catch (error) {
    if (error?.response?.data?.statusCode === 400) {
      toast.error("User not Deleted !!");
    }
    dispatch(deleteBusinessFailed());
    return "error";
  }
};

//Create Temp Business Action
// export const createBusinessAsync = (data) => (dispatch) => {
//   dispatch(createBusiness());

//   axiosInstance
//     .post("Login/CreateTempBusiness", data)
//     .then((response) => {
//       console.log(response);
//       dispatch(createBusinessSuccess(response.data));
//     })
//     .catch((err) => {
//       console.log(err);
//       dispatch(createBusinessFailed());
//     });
// };

export const createTempAccounts = (formData, navigate) => async (dispatch) => {
  dispatch(createCustomer());
  try {
    const response = await axiosMultipartInstance.post("/upload/createUser", formData);
    dispatch(createCustomerSuccess(response.data?.user));
    if (response?.statusText === 200 || 201) {
      Swal.fire({
        title: "Success",
        text: "Account Created Successfully",
        icon: "success",
        confirmButtonText: "ok",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate(-1);
        }
      });
      return response;
    }
  } catch (err) {
    console.log("errrrrr", err);
    await Swal.fire({
      title: "failed",
      text: err?.response?.data?.message || err?.response?.data?.error,
      icon: "error",
      confirmButtonText: "ok",
    });
    dispatch(createCustomerFailed(err));
    throw err;
  }
};

// Update status action ---
export const UpdateStatusAsync = (data, approveDeletionRequest = false) => async (dispatch) => {
  const { id, isReview, isAdminApproved, accountType, PrevVeried } = data;
  const resData = { id, isReview };
  if (data?.accountType === "customer") {
    dispatch(VerifyUser());
  } else if (data?.accountType === "business") {
    dispatch(VerifyBusinessUser());
  }
  try {
    let response
    if (approveDeletionRequest) {
      response = await axiosInstance.post(
        '/BusisnessUser/DeleteBusinessUser', {},
        {
          params: {
            BusinessOrCustomerId: data?.BusinessOrCustomerId,
            approvel: data?.approvel,
            adminUserId :data?.adminUserId
          },
        }

      );
    } else {
      response = await axiosInstance.post(
        "/upload/UpdateUserStatusById",
        data
      );
    }

    if ((isAdminApproved || PrevVeried) && !approveDeletionRequest) {
      if (accountType === "customer") {
        dispatch(VerifyUserSuccess(data));
      } else if (accountType === "business") {
        dispatch(updateBusinessSuccess(data));
      }
    } else if (approveDeletionRequest) {
      if (data.approvel) {
        // Approved
        if (data.accountType === "customer") {
        dispatch(VerifyUserSuccess(data));
          dispatch(deleteCustomerSuccess(data.BusinessOrCustomerId));
        } else {
          dispatch(deleteBusinessSuccess(data.BusinessOrCustomerId));
        dispatch(updateBusinessSuccess(data));

        }
      } else {
        // Rejected
        dispatch(updateDeletionRequestStatus(data));
      }
    } else {
      if (accountType === "customer") {
        dispatch(VerifyUserReviewSuccess(resData));
      } else if (accountType === "business") {
        dispatch(updateBusinessReviewSuccess(resData));
      }
    }
    return response;
  } catch (error) {
    if (data.accountType === "customer") {
      dispatch(VerifyUserFailed());
    } else if (data.accountType === "business") {
      dispatch(updateBusinessFailed());
    }

    return error;
  }
};


export const ConnectWithSelectedUser = (data) => async (dispatch) => {
  dispatch(setUserLoading(true))
  try {
     const response = await axiosInstance.post(
        "/upload/CreateConnectionWithAdmin",
        data
      );
    dispatch(setUserLoading(false))
      if(response?.data?.success ===true){
        const userData = response?.data?.updateUser || response?.data.updateUser?.user
        if(response?.data.updateUser?.message === "This user is engaged with another admin at the moment"){
          toast.error(response?.data.updateUser?.message);
        }
       
        dispatch(createUserConnectionSuccess(userData));
        return response?.data.updateUser?.message;
      }else{
        return ""
      }
  } catch (error) {
    toast.error("Something went wrong ,Please try again");
    return error;
  }
};


export const UpdatePhoneVerificationAsync = (data) => async (dispatch) => {
  try {
    dispatch(setLoading()); // Start loading
    const response = await axiosInstance.post(
      "/upload/UpdateUserStatusById",
      data
    );
    if (response.status === 200) {
      console.log("data", response);

      dispatch(refreshSuccess(response?.data?.updateUser)); // Dispatch success action
      // Swal.fire("Verification updated successfully!");
      // window.location.reload();
    } else {
      Swal.fire("Failed");
      dispatch(refreshFailed("Failed to update verification."));
    }
  } catch (err) {
    dispatch(refreshFailed(err.message)); // Handle error and dispatch failure action
    console.error("Error during refresh:", err);
  }
};

export const UpdateTempPassAsync = (data) => async (dispatch) => {
  dispatch(UpdateTempPass());
  try {
    const response = await axiosInstance.post("/Login/changePassword", data);
    if (response) {
      dispatch(UpdateTempPassSuccess(response));
      if (response.data.success === true) {
        Swal.fire({
          icon: "success",
          title: "Password updated",
        });
        return response;
      }
    }
  } catch (error) {
    console.log("error", error);
    dispatch(UpdateTempPassFailed());
    if (error?.response?.data?.statusCode !== 200 || 201) {
      Swal.fire({
        icon: "error",
        title:
          error?.response?.statusText === "Conflict"
            ? "Somethig went wrong ! try after some time "
            : error?.response?.data?.message,
      });
      return error;
    }
  }
};

export const UpdateProfileAsync = (fromData, navigate) => (dispatch) => {
  dispatch(UpdateTheProfile());
  axiosInstance
    .post("/upload/UpdateUser", fromData)
    .then((response) => {
      console.log("resp,,,", response);
      dispatch(UpdateProfileSuccess(response.data));
      if (response?.status === 200 || 201) {
        Swal.fire({
          icon: "success",
          text: "Profile Updated",
        });
        navigate(-2);
      } else {
        Swal.fire({
          icon: "error",
          text: "Failed",
        });
        // navigate(-2);
      }
    })
    .catch((err) => {
      console.log("errorrrrrr", err);
      Swal.fire({
        icon: "error",
        text: err?.response?.data?.message
          ? err?.response?.data?.message
          : err?.response?.data?.message[1],
      });
      dispatch(UpdateProfileFailed(err?.response?.data?.message[1]));
    });
};

// update message status action;

export const UpdatemessageStatusAsync = (questionId) => async (dispatch) => {
  dispatch(Update_messsage_Status());
  try {
    const response = await axiosInstance.post("/MarkAsSeen", {
      params: {
        id: questionId,
        Type: "SeenQuestion",
      },
    });
    dispatch(Update_messsage_Status_Success(response?.data));
  } catch (err) {
    dispatch(Update_messsage_Status_Failed(err?.response));
  }
};

export const getActicitiesByUserId=(data)=>async(dispatch)=>{
dispatch(fetch_activity())
try{
const resp= await  axiosInstance
    .get("/upload/activities", {
      params: {
       userId : data?.userId,
       accountType :data?.accountType,
       page :data.page,
       perPage :data.perPage
      },
    })
    console.log('data...... in activity',resp)
    resp.data.CurrentPage = data?.page;
    dispatch(fetch_activity_Success(resp?.data));
   }catch(err){
   console.log('error......',err)
   dispatch(fetch_activity_Failed(err?.response));
  
}

}

export const {
  getAllsearchBussiness,
  getAllsearchBussinessSuccess,
  getAllsearchBussinessFailed,
  getAllsearchCustomer,
  getAllsearchCustomerSuccess,
  getAllsearchCustomerFailed,
  getAllnewAccountVerifation,
  getAllnewAccountVerifationSuccess,
  getAllnewAccountVerifationFailed,
  getAllBussinessLicenseVerification,
  getAllBussinessLicenseVerificationData,
  getAllBussinessLicenseVerification_filtered_Data,
  getAllBussinessLicenseVerificationFailed,
  updateCustomer,
  updateCustomerSuccess,
  updateCustomerFailed,
  updateBusiness,
  updateBusinessSuccess,
  updateBusinessReviewSuccess,
  updateBusinessFailed,
  getAllTempBusiness,
  getAllTempBusinessSuccess,
  getAllTempBusinessFailed,
  getAllTempCustomer,
  getAllTempCustomerSuccess,
  getAllMessageSuccess,
  getAllTempCustomerFailed,
  deleteCustomer,
  deleteCustomerSuccess,
  deleteCustomerFailed,
  deleteBusiness,
  deleteBusinessSuccess,
  deleteBusinessFailed,
  createBusiness,
  createBusinessSuccess,
  createBusinessFailed,
  createCustomer,
  createCustomerSuccess,
  createCustomerFailed,
  deleteTempUserSuccess,
  deleteTempUser,
  deleteTempUserFailed,
  deleteTempStatus,
  selectedUserDetails,
  UserAccountType,
  getAllProBusiness,
  getAllProBusinessSuccess,
  getAllProBusinessFailed,
  VerifyUser,
  VerifyBusinessUser,
  VerifyUserSuccess,
  VerifyUserReviewSuccess,
  VerifyUserFailed,
  UpdateTempPass,
  UpdateTempPassSuccess,
  UpdateTempPassFailed,
  UpdateTheProfile,
  UpdateProfileSuccess,
  UpdateProfileFailed,
  SelectedFilterLocation,
  SelectedFilterToDate,
  SelectedFilterFromDate,
  setSelectedOption,
  updateDeletionRequestStatus,
  getAllAdminSuccess,
  Send_Message,
  Send_Message_Success,
  Send_Message_Failed,
  Update_messsage_Status,
  Update_messsage_Status_Success,
  Update_messsage_Status_Failed,
  AddNewMsg,
  AddNewMsgSuccess,
  AddNewMsgFailed,
  EditMsg,
  EditMsgSuccess,
  EditMsgFailed,
  UpdateIsLastMsgRead,
  setLoading,
  refreshSuccess,
  refreshFailed,
  clearLoading,
  phoneVerification,
  RefreshUserCustomer,
  RefreshUserBusiness,
  Clear_From_Date_location,
  createUserConnectionSuccess,
  updateUserConnectionWithChatSuccess,
  updateUserLastMsg,
  fetch_activity,
  fetch_activity_Success,
  fetch_activity_Failed,
  setUserLoading
} = getUsersSlice.actions;
export default getUsersSlice.reducer;